import * as Rx from 'rxjs/Rx'

import PositionInfo from './PositionInfo'

export default class DialogueView {
  private readonly positionInfo: Rx.Observable<PositionInfo>
  private readonly remove: Rx.Observable<void>
  private readonly container: HTMLElement
  private readonly message: string
  private readonly subscription = new Rx.Subscription()
  private readonly messageStayingPeriod = 30
  private div: HTMLDivElement
  private bubbleDiv: HTMLDivElement
  private messageDiv: HTMLDivElement

  constructor (
    container: HTMLElement,
    positionInfo: Rx.Observable<PositionInfo>,
    remove: Rx.Observable<void>,
    message: string
  ) {
    this.container = container
    this.positionInfo = positionInfo
    this.remove = remove
    this.message = message
  }

  mount () {
    this.div = document.createElement('div')
    this.div.className = ['animated', 'fadeIn', 'absolute', 'center'].join(' ')
    this.div.style.width = '240px'
    this.div.style.transform = 'translate(-50%, -100%)'

    this.bubbleDiv = document.createElement('div')
    this.bubbleDiv.style.maxWidth = '200px'
    this.bubbleDiv.className = [
      'inline-block',
      'border',
      'relative',
      'bg-white',
      'rounded',
      'dialog-footer-buttom'
    ].join(' ')

    this.messageDiv = document.createElement('div')
    this.messageDiv.className = ['p1', 'center', 'h4'].join(' ')
    this.messageDiv.textContent = this.message

    this.bubbleDiv.appendChild(this.messageDiv)

    this.div.appendChild(this.bubbleDiv)

    this.container.appendChild(this.div)

    this.subscription.add(
      this.positionInfo.subscribe(positionInfo => {
        this.updateState(positionInfo)
      })
    )

    this.subscription.add(
      Rx.Observable
        .defer(() => {
          const stayingPeriod = this.messageStayingPeriod || 30
          // normal fading after 30 seconds
          const normalFading = Rx.Observable
            .timer(stayingPeriod * 1000)
            .mapTo('fade')
          // forced fading introduced by new message pops up
          const forcedFading = this.remove.concat(Rx.Observable.of('fade'))
          // remove the bubble after fading animation is done
          const remove = Rx.Observable.timer(5 * 1000).mapTo('remove')
          // the following actions after add
          return Rx.Observable.race(normalFading, forcedFading).concat(remove)
        })
        .subscribe(action => {
          switch (action) {
            case 'fade':
              this.div.className = ['animated', 'fadeOut'].join(' ')
              break
            case 'remove':
              this.unmount()
              break
          }
        })
    )
  }

  unmount () {
    this.subscription.unsubscribe()
    this.container.removeChild(this.div)
  }

  private updateState (positionInfo: PositionInfo) {
    const position = {
      x: positionInfo.base.x - positionInfo.dialogueOffset.x,
      y: positionInfo.base.y - positionInfo.dialogueOffset.y
    }
    this.div.style.left = `${position.x}px`
    this.div.style.top = `${position.y}px`
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MapObjects/DialogueView.ts